import PageBaseButton from './PageBaseButton';

interface MultiSaveButtonProps {
  onClick: () => void;
}

const MultiSaveButton = ({ onClick }: MultiSaveButtonProps) => {
  return (
    <PageBaseButton
      variant="outline-danger"
      buttonText="一括追加"
      onClick={onClick}
    />
  );
};

export default MultiSaveButton;
